import { Typography } from "@mui/material";

const Footer = () => {
  return (
    <footer
      className="footer"
      style={{ padding: "1rem 0", textAlign: "center", backgroundColor: "#222" }}
    >
      <Typography variant="body2" sx={{ color: "#fff" }}>
        &copy; 2025 DesignLocker AB. Alla rättigheter reserverade.
      </Typography>
    </footer>
  );
};

export default Footer;
